<script lang="ts">
  import AutoComplete from '$shared/atoms/AutoComplete/AutoComplete.svelte';
  import Dropdown from '$shared/atoms/Dropdown/Dropdown.svelte';
  import Input from '$shared/atoms/Input/Input.svelte';
import { InputType } from '$shared/constants/InputType';
  import { GenericInputType } from './GenericInputProps';
  import AddressInput from './partials/AddressInput.svelte';
  import NameInput from './partials/NameInput.svelte';
  import EmailInput from './partials/EmailInput.svelte';
  import SchoolInput from './partials/SchoolInput.svelte';
  import CountryInput from './partials/CountryInput.svelte';
  import Checkbox from '$shared/atoms/Checkbox/Checkbox.svelte';
  import TextArea from '$shared/atoms/TextArea/TextArea.svelte';
  import CurrencyInput from '$shared/atoms/CurrencyInput/CurrencyInput.svelte';
  import type { GenericInputModel } from '$provider/models/GenericInputModel';
  import type { IAlias } from '$provider/lib/apis/interfaces/IResponse';

  let inputComp: any = $state();

  interface Props {
    option?: GenericInputModel | null;
    onchange?: (value: any) => void;
  }

  let { option = $bindable(null), onchange }: Props = $props();
  export const validate = (updatedData: any): void => {
    return validateInput(updatedData);
  };

  const validateInput = (updatedData: any): void => {
    if (!inputComp) {
      option?.setIsValid(!!updatedData);
      return;
    }
    option?.setIsValid(inputComp.isValid());
  };

  const onInputChange = (detail: any): void => {
    const value = detail?.value?.trim();
    option?.updateProps({ value });
    onchange?.(value);
  };

  const onClickAutoCompleteItem = (detail: CommonList): void => {
    option?.updateProps({ id: detail?.id, value: detail?.label });
    onchange?.(detail?.id);
  };

  const onClearAutoComplete = (): void => {
    option?.updateProps({ id: '', value: '' });
    onchange?.('');
  };

  const onDropdownChange = (detail: CommonList): void => {
    option?.updateProps({ label: detail?.label });
    onchange?.(detail?.id);
  };

  const onChangeCheckbox = (e: any): void => {
    option?.updateProps({ checked: e.target.checked });
    onchange?.(e.target.checked);
  };

  const onTextAreaChange = (e: any): void => {
    const value = e.target?.value?.trim();
    option?.updateProps({ value });
    onchange?.(value);
  };

  const onSchoolNameChange = (detail: string): void => {
    option?.updateProps({ value: detail });
    onchange?.(detail);
  };

  const onCurrencyChange = (detail: string): void => {
    const parsedValue: number = parseFloat(detail);
    const value: number | null = !isNaN(parsedValue) ? parsedValue : null;
    option?.updateProps({ value });
    option = option;
    onchange?.(value);
  };

  const onNameInputChange = (detail: IAlias): void => {
    option?.updateProps({ value: detail });
    onchange?.(detail);
  };

  const onCountryChange = (detail: string | CommonList): void => {
    if (typeof detail === 'string') {
      option?.updateProps({ value: detail });
      onchange?.(detail);
      return;
    }
    option?.updateProps({ value: detail?.label });
    onchange?.(detail?.id);
  };
</script>

<div class="comp-generic-input">
  {#if option?.inputType === GenericInputType.Dropdown}
    <Dropdown {...option?.props} maxWidth onchange={onDropdownChange} />
  {:else if option?.inputType === GenericInputType.AutoComplete}
    <AutoComplete
      {...option?.props}
      onclick={onClickAutoCompleteItem}
      oncleared={onClearAutoComplete}
    />
  {:else if option?.inputType === GenericInputType.SchoolInput}
    <SchoolInput {...option?.props} onchange={onSchoolNameChange} />
  {:else if option?.inputType === GenericInputType.Date}
    <Input {...option?.props} type={InputType.Date} oninput={onInputChange} />
  {:else if option?.inputType === GenericInputType.AliasInput}
    <NameInput {...option?.props} onchange={onNameInputChange} />
  {:else if option?.inputType === GenericInputType.AddressInput}
    <AddressInput bind:this={inputComp} {...option?.props} {onchange} />
  {:else if option?.inputType === GenericInputType.EmailInput}
    <EmailInput bind:this={inputComp} {...option?.props} {onchange} />
  {:else if option?.inputType === GenericInputType.Checkbox}
    <Checkbox {...option?.props} onchange={onChangeCheckbox} />
  {:else if option?.inputType === GenericInputType.TextArea}
    <TextArea {...option?.props} oninput={onTextAreaChange} />
  {:else if option?.inputType === GenericInputType.CurrencyInput}
    <CurrencyInput {...option?.props} oninput={onCurrencyChange} />
  {:else if option?.inputType === GenericInputType.CountryInput}
    <CountryInput {...option?.props} onchange={onCountryChange} />
  {:else}
    <Input {...option?.props} oninput={onInputChange} />
  {/if}
</div>

<style>
  .comp-generic-input {
    width: inherit;
  }
</style>
